import { render, staticRenderFns } from "./menu-tree-item.vue?vue&type=template&id=e49c28a8&scoped=true&"
import script from "./menu-tree-item.vue?vue&type=script&lang=js&"
export * from "./menu-tree-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree-item.vue?vue&type=style&index=0&id=e49c28a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49c28a8",
  null
  
)

export default component.exports